import {DeviceSize} from '../../theme/helpers';
import {useStyles} from '../../hooks/styles';

export const GetStyle = () => {
  return useStyles(({theme, mediaOnly}) => ({
    container: {
      borderRadius: 40,
      backgroundColor: theme.color.blue100,
      overflow: 'hidden',
      paddingBottom: 24,
    },
    textContainer: {
      ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 24}, {paddingHorizontal: 16}),
      flexGrow: 1,
    },
    imageContainer: {
      ...mediaOnly(DeviceSize.desktop, {padding: 24, paddingBottom: 15}, {padding: 16}),
    },
    image: {
      borderRadius: 32,
      ...mediaOnly(DeviceSize.desktop, {height: 135}, {height: 142}),
    },
    date: {
      color: theme.color.gray500,
      marginBottom: 8,
    },
    description: {
      color: theme.color.textColor,
    },
    button: {
      width: 200,
      height: 36,
      alignSelf: 'center',
    },
    textHeader: {
      ...mediaOnly(DeviceSize.desktop, {marginBottom: 12}, {marginBottom: 16}),
    },
  }));
};
